var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPasswordHide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.963,
    height: 12.769,
    viewBox: "0 0 15.963 12.769",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -49.023)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 49.023)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#23304b",
    d: "M14.192,49.2a.587.587,0,0,0-.831,0L11.276,51.28a7.987,7.987,0,0,0-7.968.831,13.315,13.315,0,0,0-3.2,2.951.591.591,0,0,0,.016.717A14.4,14.4,0,0,0,3.6,58.955L1.768,60.789a.586.586,0,1,0,.827.831l11.6-11.593A.59.59,0,0,0,14.192,49.2ZM6.53,56.027a1.525,1.525,0,0,1-.127-.619,1.579,1.579,0,0,1,2.2-1.453Zm2.938-2.935a2.749,2.749,0,0,0-3.8,3.8L4.462,58.1a12.337,12.337,0,0,1-3.114-2.7,12.547,12.547,0,0,1,2.6-2.306,6.836,6.836,0,0,1,6.434-.915Z",
    transform: "translate(0 -49.023)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.885 52.427)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#23304b",
    d: "M190.611,156.122a15.7,15.7,0,0,0-2.485-2.485.588.588,0,1,0-.726.925,14.006,14.006,0,0,1,1.994,1.938,12.852,12.852,0,0,1-2.15,2,7.246,7.246,0,0,1-5.873,1.528.586.586,0,1,0-.241,1.147,7.3,7.3,0,0,0,1.525.16,7.75,7.75,0,0,0,2.316-.362,10.342,10.342,0,0,0,2.994-1.547,13.456,13.456,0,0,0,2.665-2.583A.591.591,0,0,0,190.611,156.122Z",
    transform: "translate(-180.663 -153.512)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordHide);
export default __webpack_public_path__ + "static/media/passwordHide.7ff75497.svg";
export { ForwardRef as ReactComponent };